<template>
    <Navbar :center-text="$t('AdvisoryActivitiesView.reportingActivities')"></Navbar>
    <div class="container mt-4">
      <div class="row">
        <div class="col-12 d-flex flex-wrap cards-container justify-content-center align-items-center">
          <div class="card card-yellow text-center shadow-sm">
            <div class="card-body">
              <h5 class="card-title">{{ $t('FarmerAdviceView.farmerAdvice') }}</h5>
              <p class="card-text">{{ $t('FarmerAdviceView.farmerAdviceDescription') }}</p>
              <button class="btn btn-yellow"
                      @click="this.$router.push({ name: 'farmer-advice' });">
                <i class="bi bi-arrow-right-circle"></i>
                {{ $t('AdvisoryActivitiesView.start') }}
              </button>
            </div>
          </div>

          <div class="card card-beige text-center shadow-sm">
            <div class="card-body">
              <h5 class="card-title">{{ $t('GroupAdviceView.groupAdvice') }}</h5>
              <p class="card-text">{{ $t('GroupAdviceView.groupAdviceDescription') }}</p>
              <button class="btn btn-beige"
                      @click="this.$router.push({ name: 'group-advice' });">
                <i class="bi bi-arrow-right-circle"></i>
                {{ $t('AdvisoryActivitiesView.start') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  <Footerbar></Footerbar>
</template>


<script>
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import { sharedState } from "@/store";

export default {
  data(){
    return {
      sharedState
    }
  },
  components: {
    Navbar,
    Footerbar,
  }
};
</script>

<style scoped>

.card {
  border: none;
  border-radius: 8px;
  width: 300px !important;
  height: 180px !important;
}

.card-yellow {
  background-color: #EBB02E !important;
  color: #63432A !important;
}

.card-beige {
  background-color: #E7DBC0 !important;
  color: #63432A !important;
}

.btn-yellow {
  background-color: #EBB02E !important;
  color: #63432A !important;
  border: 1px solid #63432A !important;
  padding: 8px 16px;
  font-size: 0.9rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease, border-color 0.2s ease;
}

.btn-beige {
  background-color: #E7DBC0 !important;
  color: #63432A !important;
  border: 1px solid #63432A !important;
  padding: 8px 16px;
  font-size: 0.9rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease, border-color 0.2s ease;
}


.btn-yellow:hover {
  transform: scale(1.05);
}

.btn-yellow:active {
  transform: scale(1);
}

.btn-beige:hover {
  transform: scale(1.05);
}

.btn-beige:active {
  transform: scale(1);
}

</style>